import type { Components } from "@mui/material/styles";

export const MuiDialogTitle: Components["MuiDialogTitle"] = {
  styleOverrides: {
    root: {
      padding: "var(--rhythm) calc(1.5 * var(--rhythm))",
      fontSize: "var(--font-size-h2)",
    },
  },
};

export const MuiDialogContent: Components["MuiDialogContent"] = {
  styleOverrides: {
    root: {
      padding: "var(--rhythm) calc(1.5 * var(--rhythm))",
    },
  },
};

export const MuiDialogActions: Components["MuiDialogActions"] = {
  styleOverrides: {
    root: {
      padding: "var(--rhythm) calc(1.5 * var(--rhythm))",
    },
    spacing: {
      gap: "calc(0.5 * var(--rhythm))",
    },
  },
};
